/* ============================================================================
FILE: po-katupirsia5-sceau-de-yuyarina-texts-fr-en-es-20260307.js

MODE: TRILINGUE (FR/EN/ES) + lexicon injection (if present)

API:  window.PoKatupirsia5SceauDeYuyarinaTextsFR_EN_ES_20260307

ROOT: .po-axis-section[data-po-axis]

ROLE:
  - Injecte le contenu FR/EN/ES dans les slots selon la langue (navigateur ou storage).
  - Protection fine: verrouille (translate="no") TOUTES les occurrences du lexique simplifié (si disponible),
    avec variantes apostrophes + œ/oe, et anti-collage (espaces DOM/HTML uniquement quand nécessaire).
  - IMPORTANT: les termes du lexique (et variantes) restent en FR, quelle que soit la langue affichée.
  - Compat: conserve un alias API window.GoodyTwinLang (getLang/setLang/init) pour éviter de casser d’anciens appels.
  - Ajoute une couche audio locale et générale sans toucher au socle multilingue, au nom du fichier,
    ni aux protections lexicales.
============================================================================ */

(function(){

  "use strict";

  if (window.__PO_KATUPIRSIA5_SCEAU_DE_YUYARINA_TEXTS_20260307__) return;
  window.__PO_KATUPIRSIA5_SCEAU_DE_YUYARINA_TEXTS_20260307__ = true;

  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-axis-section[data-po-axis]';

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var v = (raw == null) ? "" : String(raw);
    v = v.toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      v = normLang(v);
      if (v) return v;
    }catch(e){}
    try{
      var v2 = localStorage.getItem(STORAGE_KEY_COMPAT);
      v2 = normLang(v2);
      if (v2) return v2;
    }catch(e){}
    return "";
  }

  function storeLang(lang){
    var v = normLang(lang) || "fr";
    try{ localStorage.setItem(STORAGE_KEY, v); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, v); }catch(e){}
    try{ document.documentElement.setAttribute("lang", v); }catch(e){}
    return v;
  }

  function detectBrowserLang(){
    try{
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    }catch(e){}
    return "fr";
  }

  function getLang(){
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* --------------------------------------------------------------------------
   * LEXIQUE RUNTIME
   * -------------------------------------------------------------------------- */

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}

    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}

    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickDefShort(entry, lang){
    if (!entry) return "";
    var ks = "definition_short_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[ks]) return clampStr(entry[ks]);
      if (entry[k])  return clampStr(entry[k]);
    }catch(e){}
    return "";
  }

  function pickDefLong(entry, lang){
    if (!entry) return "";
    var kl = "definition_long_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[kl]) return clampStr(entry[kl]);
      if (entry[k])  return clampStr(entry[k]);
    }catch(e){}
    return "";
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + "_" + lang;
    try{
      var v = entry[k];
      if (Array.isArray(v)) return v;
    }catch(e){}
    return [];
  }

  /* --------------------------------------------------------------------------
   * PROTECTION fine
   * -------------------------------------------------------------------------- */

  function protectSpan(txt){
    return '<span translate="no" class="po-lex-protect">' + clampStr(txt) + "</span>";
  }

  function uniqPush(arr, v){
    if (!v) return;
    for (var i=0;i<arr.length;i++){
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term){
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);

    var a1 = t.replace(/’/g, "'");
    var a2 = t.replace(/'/g, "’");
    uniqPush(out, a1);
    uniqPush(out, a2);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    uniqPush(out, oe1);

    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe2);

    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta &&
          Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)){
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)){
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    }catch(e){}

    return [
      "Sceau de Yuyarina",
      "Yuyarina",
      "Yuyarīnâ",
      "Posœnnoïsme",
      "Posœnnoïa",
      "Organon posœnnoïal",
      "Katûvýsissence",
      "Katûvýs",
      "Ennéagone",
      "Isqun",
      "Threnisqun",
      "Tiqqunbahu",
      "Takimarah",
      "Àpákan",
      "RéZonans",
      "Balakallpa",
      "Katûsýs",
      "Katûvýsqun",
      "Sujet pluriel",
      "Superposition de perspectives",
      "Addition synchrêtique",
      "Instantané multiple",
      "Humanus"
    ];
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function buildProtectMatcher(){
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i=0;i<base.length;i++){
      var vlist = buildVariants(base[i]);
      for (var j=0;j<vlist.length;j++){
        uniqPush(variants, vlist[j]);
      }
    }

    variants.sort(function(a,b){ return b.length - a.length; });

    var parts = [];
    for (var k=0;k<variants.length;k++){
      if (!variants[k]) continue;
      parts.push(escapeRegExp(variants[k]));
    }
    if (!parts.length) return null;

    try{
      return new RegExp("(" + parts.join("|") + ")", "g");
    }catch(e){
      return null;
    }
  }

  var __PO_PROTECT_RE__ = null;

  function protectKeywordsHTML(html){
    if (!html) return "";
    var out = String(html);

    if (!__PO_PROTECT_RE__){
      __PO_PROTECT_RE__ = buildProtectMatcher();
    }
    if (__PO_PROTECT_RE__){
      out = out.replace(__PO_PROTECT_RE__, function(m){
        return protectSpan(m);
      });
    }

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect">)/g, function(_m, a, b){
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });

    return out;
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: "",
    lang: "fr",
    voice: null
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){
    var L = normLang(lang);
    return AUDIO_UI[L] || AUDIO_UI.fr;
  }

  function getAudioRoots(){
    try{ return document.querySelectorAll(ROOT_SEL); }catch(e){ return []; }
  }

  function getDetailBlocks(root){
    if (!root || !root.querySelectorAll) return [];
    try{ return root.querySelectorAll(".po-lex-details"); }catch(e){ return []; }
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-axis-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-axis-audio-styles";
    style.textContent =
      ".po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;justify-content:flex-start;}" +
      ".po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(184,134,11,.55);background:rgba(31,122,58,.04);color:var(--color-accent,#1f7a3a);padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;font-weight:800;line-height:1.2;transition:opacity .2s ease,transform .2s ease,box-shadow .2s ease,border-color .2s ease;box-shadow:0 6px 16px rgba(31,122,58,.10);}" +
      ".po-axis-audio-btn:hover{transform:translateY(-1px);box-shadow:0 10px 26px rgba(31,122,58,.16);border-color:rgba(184,134,11,.75);}" +
      ".po-axis-audio-btn[aria-pressed='true']{box-shadow:0 0 0 1px rgba(184,134,11,.18),0 10px 26px rgba(31,122,58,.18);background:rgba(31,122,58,.08);}" +
      ".po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;flex:0 0 auto;}" +
      "@media (max-width:640px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}";
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role === "general" ? "general" : "detail");
    btn.setAttribute("aria-pressed", "false");
    btn.setAttribute("translate", "yes");
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel){
      var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap";
        generalWrap.setAttribute("data-po-audio-role", "general");

        var generalBtn = createAudioButton("general");
        generalWrap.appendChild(generalBtn);

        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetail = panel.querySelector(".po-lex-details");

        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        } else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        } else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        } else {
          panel.appendChild(generalWrap);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var detail = details[i];
      var summary = detail.querySelector(".po-lex-summary");
      if (!summary) continue;

      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-role='detail']");
      if (!btn){
        btn = createAudioButton("detail");
        summary.appendChild(btn);
      }
      btn.setAttribute("data-po-audio-index", String(i));
    }
  }

  function getTextValue(el){
    if (!el) return "";
    var txt = "";
    try{ txt = el.innerText || el.textContent || ""; }catch(e){ txt = ""; }
    txt = String(txt).replace(/\s+/g, " ").replace(/\u00a0/g, " ").trim();
    return txt;
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn, .po-axis-audio-wrap");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
    }
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join(". ");
  }

  function collectDetailText(detail){
    if (!detail) return "";
    var parts = [];

    var title = detail.querySelector(".po-lex-summary__title");
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);

    var clone = detail.cloneNode(true);
    var summary = clone.querySelector(".po-lex-summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);

    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);

    return parts.join(". ");
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ]/.test(ch || "");
  }

  function splitTextForSpeech(txt, maxLen){
    var text = clampStr(txt).replace(/\s+/g, " ").trim();
    if (!text) return [];
    var limit = Math.max(120, parseInt(maxLen, 10) || 200);
    var out = [];
    var start = 0;

    while (start < text.length){
      var end = Math.min(start + limit, text.length);
      if (end < text.length){
        var slice = text.slice(start, end);
        var cut = Math.max(
          slice.lastIndexOf(". "),
          slice.lastIndexOf("! "),
          slice.lastIndexOf("? "),
          slice.lastIndexOf("; "),
          slice.lastIndexOf(": "),
          slice.lastIndexOf(", ")
        );
        if (cut < Math.floor(limit * 0.55)){
          cut = slice.lastIndexOf(" ");
        }
        if (cut > 0) end = start + cut + 1;
      }

      while (end < text.length && isWordLikeChar(text.charAt(end - 1)) && isWordLikeChar(text.charAt(end))){
        end++;
      }

      var chunk = text.slice(start, end).trim();
      if (chunk) out.push(chunk);
      start = end;
    }

    return out;
  }

  function pickVoiceForLang(lang){
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== "function") return null;
    var wanted = normLang(lang) || "fr";
    var voices = [];
    try{ voices = PO_AUDIO_SYNTH.getVoices() || []; }catch(e){ voices = []; }
    if (!voices.length) return null;

    var i, v, voiceLang;
    for (i=0;i<voices.length;i++){
      v = voices[i];
      voiceLang = normLang(v && v.lang);
      if (voiceLang === wanted) return v;
    }
    for (i=0;i<voices.length;i++){
      v = voices[i];
      voiceLang = clampStr(v && v.lang).toLowerCase();
      if (voiceLang.indexOf(wanted) === 0) return v;
    }
    return voices[0] || null;
  }

  function buildUnits(root, role, index){
    var units = [];
    var details = getDetailBlocks(root);

    if (role === "general"){
      units.push({ role: "general", index: -1 });
      for (var i=0;i<details.length;i++){
        units.push({ role: "detail", index: i });
      }
      return units;
    }

    var start = (typeof index === "number" && index >= 0) ? index : 0;
    for (var j=start;j<details.length;j++){
      units.push({ role: "detail", index: j });
    }
    return units;
  }

  function updateAudioPressedState(){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      var root = roots[i];
      var btns = root.querySelectorAll(".po-axis-audio-btn");
      for (var j=0;j<btns.length;j++){
        btns[j].setAttribute("aria-pressed", "false");
      }
    }

    if (!PO_AUDIO_STATE.root || !PO_AUDIO_STATE.activeKey) return;

    var btn;
    if (PO_AUDIO_STATE.activeKey === "general"){
      btn = PO_AUDIO_STATE.root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general'] .po-axis-audio-btn[data-po-audio-role='general']");
      if (btn) btn.setAttribute("aria-pressed", "true");
      return;
    }

    var idx = parseInt(String(PO_AUDIO_STATE.activeKey).split(":")[1], 10);
    if (!isNaN(idx)){
      btn = PO_AUDIO_STATE.root.querySelector(".po-axis-audio-btn[data-po-audio-role='detail'][data-po-audio-index='" + idx + "']");
      if (btn) btn.setAttribute("aria-pressed", "true");
    }
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var ui = audioUI(lang || getLang());

    var generalBtn = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general'] .po-axis-audio-btn[data-po-audio-role='general']");
    if (generalBtn){
      var generalActive = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === "general" && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      generalBtn.textContent = generalActive ? ui.stop : ui.general;
    }

    var detailBtns = root.querySelectorAll(".po-axis-audio-btn[data-po-audio-role='detail']");
    for (var i=0;i<detailBtns.length;i++){
      var btn = detailBtns[i];
      var idx = parseInt(btn.getAttribute("data-po-audio-index"), 10);
      var key = "detail:" + (isNaN(idx) ? -1 : idx);
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      btn.textContent = active ? ui.stop : ui.block;
    }

    updateAudioPressedState();
  }

  function refreshAllAudioLabels(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  function stopAudio(silent){
    if (PO_AUDIO_SYNTH){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.voice = null;
    if (!silent) refreshAllAudioLabels(getLang());
    else updateAudioPressedState();
  }

  function speakCurrentChunk(){
    if (!PO_AUDIO_SYNTH) return;

    if (!PO_AUDIO_STATE.chunks.length || PO_AUDIO_STATE.chunkPos < 0 || PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }

    var txt = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!txt){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
      return;
    }

    var utter = new SpeechSynthesisUtterance(txt);
    utter.lang = (PO_AUDIO_STATE.lang || getLang() || "fr");
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;

    utter.onend = function(){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    };

    utter.onerror = function(){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    };

    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    }
  }

  function playCurrentUnit(skipCancel){
    if (!PO_AUDIO_SYNTH) return;

    if (!skipCancel){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }

    if (!PO_AUDIO_STATE.root || PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (!unit){
      stopAudio();
      return;
    }

    var text = "";
    if (unit.role === "general"){
      PO_AUDIO_STATE.activeKey = "general";
      text = collectGeneralText(PO_AUDIO_STATE.root);
    } else {
      PO_AUDIO_STATE.activeKey = "detail:" + unit.index;
      var details = getDetailBlocks(PO_AUDIO_STATE.root);
      var detail = details[unit.index];
      if (detail){
        try{ detail.open = true; }catch(e){}
      }
      text = collectDetailText(detail);
    }

    PO_AUDIO_STATE.chunks = splitTextForSpeech(text, 210);
    PO_AUDIO_STATE.chunkPos = 0;
    refreshAllAudioLabels(PO_AUDIO_STATE.lang || getLang());

    if (!PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }

    speakCurrentChunk();
  }

  function startAudio(root, role, index){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio(true);

    var lang = getLang();

    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);

    refreshAllAudioLabels(lang);
    playCurrentUnit(false);
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poAudioBound) continue;

      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();

        var role = this.getAttribute("data-po-audio-role") || "detail";
        var index = parseInt(this.getAttribute("data-po-audio-index"), 10);
        var key = (role === "general") ? "general" : ("detail:" + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);

        if (sameRoot && sameKey && (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending))){
          stopAudio();
          return;
        }

        startAudio(root, role, isNaN(index) ? -1 : index);
      });

      btn.__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === "function"){
      PO_AUDIO_SYNTH.addEventListener("voiceschanged", function(){
        if (PO_AUDIO_STATE.root){
          PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
        }
      });
    }
  }catch(e){}

  /* --------------------------------------------------------------------------
   * SLOTS helpers
   * -------------------------------------------------------------------------- */

  function qs(root, sel){
    try{ return root.querySelector(sel); }catch(e){ return null; }
  }

  function setSlotText(root, slot, txt){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(html);
  }

  function setSlotImg(root, slot, src, alt){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;

    var s = clampStr(src);
    var a = clampStr(alt);

    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt",""); }catch(e){}
      try{ el.style.display = "none"; }catch(e){}
      return;
    }

    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.style.display = ""; }catch(e){}
  }

  function setSlotImgSrc(root, slot, src, alt){
    setSlotImg(root, slot, src, alt);
  }

  function renderList(root, slot, items){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      out.push("<li>" + protectKeywordsHTML(clampStr(arr[i])) + "</li>");
    }
    el.innerHTML = out.join("");
  }

  function renderExampleBox(root, slot, exampleTitle, exampleText){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var t = clampStr(exampleTitle);
    var x = clampStr(exampleText);
    if (!t && !x){
      el.innerHTML = "";
      return;
    }
    var html = '<div class="po-lex-example__title"><strong>' + protectKeywordsHTML(t) + '</strong></div>' +
               '<div class="po-lex-example__text">' + protectKeywordsHTML(x) + "</div>";
    el.innerHTML = html;
  }

  function renderWordBlocks(root, slot, blocks){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      var h = clampStr(b.head);
      var t = clampStr(b.text);
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectKeywordsHTML(h) + '</div>' +
          '<div class="po-axis-wb__t">' + protectKeywordsHTML(t) + '</div>' +
        '</div>'
      );
    }
    el.innerHTML = out.join("");
  }

  /* --------------------------------------------------------------------------
   * IMAGES (Sceau de Yuyarina)
   * -------------------------------------------------------------------------- */

  var IMG_IDEOGRAM_CONCEPT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_Yuyarina_286_2.png?v=1772905412";
  var IMG_IDEOGRAM_FUNCTION = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_Yuyarina_286_3_copie_2.png?v=1772905496";
  var IMG_GUIDE_NUMBER_286 = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_286.png?v=1773449437";

  /* --------------------------------------------------------------------------
   * FALLBACKS
   * -------------------------------------------------------------------------- */

  var FALLBACK_FR = {
    title: "Sceau de Yuyarina",
    kicker: "Katûpirsia 5 — Sceau régulateur de l’Ennéagone spiralé",
    cta_translate: "Proposer une traduction du concept",
    h_def: "Définition opérative",
    chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel", "Nombre guide"],
    chip_urls: [ IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_286 ],
    def_short:
      "Le Sceau de Yuyarina est une structure vibratoire de réorientation du sens. Il agit lorsque le geste, la parole ou le rituel perdent leur charge interne, et réactive la mémoire dans l’acte par variation juste, sans rupture de forme.",
    def_long:
      "Le Sceau de Yuyarina intervient au moment précis où une pratique encore vivante en apparence commence à s’user intérieurement. Le geste continue, la forme subsiste, le rite se répète, l’œuvre avance ; pourtant quelque chose de l’axe s’est déplacé, du souffle s’est retiré, de la présence s’est amenuisée. Yuyarina capte cette érosion symbolique avant qu’elle ne devienne perte durable.\n\n" +
      "Son lien matriciel relie la mémoire vibratoire à la direction poïétique. Il ne restaure pas mécaniquement un état antérieur : il remet en marche la mémoire active dans le geste, introduit une inflexion juste, une variation subtile, une reprise d’axe. Là où l’habitude s’installait, il rouvre la trajectoire.\n\n" +
      "Dans K5, Yuyarina est distinct de Katûsýs, de Balakallpa et de Katûvýsqun. Il se tient comme interface spiralée de régénération du sens dans l’acte. Sa fréquence 286 marque un état où la mémoire reprend mouvement, où la répétition cesse d’être inertie et devient fidélité vivante par déplacement juste.",
    h_features: "Repères structurants",
    h_questions: "Repères d’activation",
    hint_fold: "déplier",
    example_title: "Formulation canonique",
    example:
      "1) Si un geste se répète sans vibration : « Yuyarina réoriente ». 2) Si un rituel devient routine : « Yuyarina introduit la variation ». 3) Si le sens s’éteint lentement : « Yuyarina remet la marche ».",
    features: [
      "Statut : Sceau régulateur de l’Ennéagone spiralé.",
      "Lien matriciel : relie la mémoire vibratoire à la direction poïétique.",
      "Fonction principale : réactivation du sens dans les pratiques devenues linéaires ou mécaniques.",
      "Nature : ni Katûsýs, ni Balakallpa, ni Katûvýsqun — interface spiralée de régénération du sens dans l’acte.",
      "Fréquence harmonique : 286.",
      "Type : catalyseur de régénérescence du sens.",
      "Dimensions d’action : pratiques rituelles ; geste artistique ou performatif ; langage symbolique ; mémoires fractales affaiblies."
    ],
    questions: [
      "Le geste continue-t-il alors que la vibration s’est retirée ?",
      "S’agit-il d’une répétition nécessaire, ou d’une routine qui a perdu son axe ?",
      "Le sens demande-t-il correction, ou glissement poïétique intérieur ?",
      "Quelle source mémorielle doit être rappelée avant toute variation ?",
      "Faut-il identifier le fragment en érosion, rappeler yuyay, introduire rina, puis clore par la verbalisation du souffle retrouvé ?"
    ],
    h_family: "Affinités posœnnoïales",
    family_1:
      "<p><strong>Position dans La Katûvýs :</strong> le Sceau de Yuyarina se situe à l’intersection de <span translate=\"no\" class=\"po-lex-protect\">Tiqqunbahu</span> et des <span translate=\"no\" class=\"po-lex-protect\">Takimarah</span>. Il agit comme amorce de relance symbolique dans tout <span translate=\"no\" class=\"po-lex-protect\">Àpákan</span> où l’élan initial est devenu inertie. Il relance la spirale de signification sans rompre la structure : par glissement, par résonance, par retournement subtil.</p>",
    family_2:
      "<p><strong>Entité isqunienne associée :</strong> <span translate=\"no\" class=\"po-lex-protect\">Yuyarīnâ</span> est l’émanation opérative du Sceau de Yuyarina. Elle recompose ce qui s’effiloche lorsque le sens s’érode par répétition, redonne tenue à la pratique, plasticité à la forme et mémoire active à la direction. Dans la logique <span translate=\"no\" class=\"po-lex-protect\">Isqun</span> → <span translate=\"no\" class=\"po-lex-protect\">Threnisqun</span>, elle condense la reprise d’axe en geste situé.</p>",
    h_wordbuild: "Positionnements & comparaisons",
    word_blocks: [
      {
        head: "Formation du nom",
        text:
          "Yuyarina vient du quechua yuyay — mémoire, pensée vivante — et rina — marche, direction, passage. La composition désigne une mémoire qui se remet en route, une conscience qui reprend sa trajectoire, une fidélité vivante qui refuse l’inertie."
      },
      {
        head: "Fonctionnement rituelo-symbolique",
        text:
          "Identifier le fragment de pratique en érosion. Rappeler la source mémorielle, yuyay. Introduire un déplacement poïétique, rina : inflexion, variation, réinterprétation. Clôturer par une verbalisation du nouveau souffle ressenti afin d’inscrire la reprise dans la conscience opérative."
      },
      {
        head: "Tableau d’activation",
        text:
          "Perte de sens dans un rituel : répétition automatique, variation juste. Geste vidé de sa vibration : mécanisation du corps, réincarnation symbolique. Langage vidé de son pouvoir : formules mortes, réécriture intuitive. Mémoire rituelle effacée : oubli de l’origine, réinscription vibratoire."
      },
      {
        head: "Portée philosophique",
        text:
          "Tout vivant s’érode. L’usure du sens appartient au réel. Yuyarina transforme cette érosion en variation créatrice : le sens n’est pas restauré comme un objet, il est redéployé dans la spirale. L’habitude retrouve trajectoire, le geste reprend courbe, la mémoire devient marche."
      }
    ],
    word_notes: [
      "Yuyarina ne corrige pas de l’extérieur ; il réoriente de l’intérieur.",
      "La variation juste y devient fidélité vivante plutôt qu’infidélité à la forme.",
      "Il agit lorsque l’acte se maintient alors que sa charge interne s’effiloche.",
      "Phrase opérative : « Yuyarina : je reconnais l’usure, je rappelle la mémoire, j’introduis la variation juste, et le geste reprend sa courbe dans la spirale. »"
    ]
  };

  var FALLBACK_EN = {
    title: "Sceau de Yuyarina",
    kicker: "Katûpirsia 5 — Regulatory seal of the spiral Ennéagone",
    cta_translate: "Suggest a translation of the concept",
    h_def: "Operational definition",
    chips: ["Conceptual ideogram", "Functional ideogram", "Guide number"],
    chip_urls: [ IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_286 ],
    def_short:
      "Sceau de Yuyarina is a vibratory structure of reorientation of meaning. It acts when gesture, speech, or ritual lose their inner charge, and reactivates memory within the act through a just variation, without breaking form.",
    def_long:
      "Sceau de Yuyarina intervenes at the precise moment when a practice still alive in appearance begins to wear internally. The gesture continues, the form remains, the rite repeats, the work advances; yet something of the axis has shifted, breath has withdrawn, presence has grown thinner. Yuyarina captures that symbolic erosion before it becomes lasting loss.\n\n" +
      "Its matrix link connects vibratory memory to poietic direction. It does not mechanically restore a previous state: it sets active memory back in motion within the gesture, introduces a just inflection, a subtle variation, a renewed axis. Where habit was settling, it reopens trajectory.\n\n" +
      "In K5, Yuyarina is distinct from Katûsýs, Balakallpa, and Katûvýsqun. It stands as a spiral interface of regeneration of meaning within the act. Its frequency 286 marks a state in which memory resumes movement, repetition ceases to be inertia, and becomes living fidelity through just displacement.",
    h_features: "Structural markers",
    h_questions: "Activation markers",
    hint_fold: "unfold",
    example_title: "Canonical formulation",
    example:
      "1) If a gesture repeats without vibration: “Yuyarina reorients.” 2) If a ritual becomes routine: “Yuyarina introduces variation.” 3) If meaning slowly fades: “Yuyarina sets the movement back.”",
    features: [
      "Status: regulatory seal of the spiral Ennéagone.",
      "Matrix link: connects vibratory memory to poietic direction.",
      "Main function: reactivation of meaning in practices that have become linear or mechanical.",
      "Nature: neither Katûsýs, nor Balakallpa, nor Katûvýsqun — spiral interface of regeneration of meaning within the act.",
      "Harmonic frequency: 286.",
      "Type: catalyst of regeneration of meaning.",
      "Dimensions of action: ritual practices; artistic or performative gesture; symbolic language; weakened fractal memories."
    ],
    questions: [
      "Does the gesture continue while vibration has withdrawn?",
      "Is this a necessary repetition, or a routine that has lost its axis?",
      "Does meaning call for correction, or for an inner poietic shift?",
      "Which memorial source must be recalled before any variation?",
      "Should one identify the fragment in erosion, recall yuyay, introduce rina, then close with the verbalisation of recovered breath?"
    ],
    h_family: "Posœnnoïal affinities",
    family_1:
      "<p><strong>Position in the Katûvýs:</strong> Sceau de Yuyarina lies at the intersection of <span translate=\"no\" class=\"po-lex-protect\">Tiqqunbahu</span> and the <span translate=\"no\" class=\"po-lex-protect\">Takimarah</span>. It acts as a symbolic relaunch within any <span translate=\"no\" class=\"po-lex-protect\">Àpákan</span> where initial impulse has become inertia. It relaunches the spiral of signification without breaking structure: through sliding, resonance, and subtle turning.</p>",
    family_2:
      "<p><strong>Associated Isqunian entity:</strong> <span translate=\"no\" class=\"po-lex-protect\">Yuyarīnâ</span> is the operative emanation of Sceau de Yuyarina. It recomposes what frays when meaning erodes through repetition, restores holding to practice, plasticity to form, and active memory to direction. In the logic <span translate=\"no\" class=\"po-lex-protect\">Isqun</span> → <span translate=\"no\" class=\"po-lex-protect\">Threnisqun</span>, it condenses renewed axis into situated gesture.</p>",
    h_wordbuild: "Positions & comparisons",
    word_blocks: [
      {
        head: "Formation of the name",
        text:
          "Yuyarina comes from the Quechua yuyay — memory, living thought — and rina — movement, direction, passage. The composition names a memory set back into motion, a consciousness recovering its trajectory, a living fidelity refusing inertia."
      },
      {
        head: "Ritual-symbolic functioning",
        text:
          "Identify the fragment of practice in erosion. Recall the memorial source, yuyay. Introduce a poietic displacement, rina: inflection, variation, reinterpretation. Close with a verbalisation of the newly felt breath so that the recovery is inscribed in operative consciousness."
      },
      {
        head: "Activation table",
        text:
          "Loss of meaning in a ritual: automatic repetition, just variation. Gesture emptied of vibration: mechanisation of the body, symbolic re-embodiment. Language emptied of power: dead formulas, intuitive rewriting. Ritual memory erased: forgetting origin, vibratory reinscription."
      },
      {
        head: "Philosophical scope",
        text:
          "Everything living erodes. The wearing of meaning belongs to reality. Yuyarina transforms that erosion into creative variation: meaning is not restored as an object, it is redeployed in the spiral. Habit regains trajectory, gesture recovers curve, memory becomes movement."
      }
    ],
    word_notes: [
      "Yuyarina does not correct from outside; it reorients from within.",
      "Just variation becomes living fidelity rather than betrayal of form.",
      "It acts when the act remains while its inner charge is fraying.",
      "Operative phrase: “Yuyarina : I recognise wear, I recall memory, I introduce just variation, and the gesture recovers its curve in the spiral.”"
    ]
  };

  var FALLBACK_ES = {
    title: "Sceau de Yuyarina",
    kicker: "Katûpirsia 5 — Sello regulador del Ennéagone espiral",
    cta_translate: "Proponer una traducción del concepto",
    h_def: "Definición operativa",
    chips: ["Ideograma conceptual", "Ideograma funcional", "Número guía"],
    chip_urls: [ IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_286 ],
    def_short:
      "El Sceau de Yuyarina es una estructura vibratoria de reorientación del sentido. Actúa cuando el gesto, la palabra o el ritual pierden su carga interna, y reactiva la memoria en el acto por variación justa, sin romper la forma.",
    def_long:
      "El Sceau de Yuyarina interviene en el momento preciso en que una práctica todavía viva en apariencia empieza a desgastarse por dentro. El gesto continúa, la forma subsiste, el rito se repite, la obra avanza; sin embargo, algo del eje se ha desplazado, el soplo se ha retirado, la presencia se ha adelgazado. Yuyarina capta esa erosión simbólica antes de que se convierta en pérdida duradera.\n\n" +
      "Su vínculo matricial conecta la memoria vibratoria con la dirección poiética. No restaura mecánicamente un estado anterior: vuelve a poner en marcha la memoria activa dentro del gesto, introduce una inflexión justa, una variación sutil, una recuperación del eje. Allí donde se instalaba la costumbre, reabre la trayectoria.\n\n" +
      "En K5, Yuyarina es distinto de Katûsýs, de Balakallpa y de Katûvýsqun. Se sostiene como interfaz espiral de regeneración del sentido en el acto. Su frecuencia 286 marca un estado en el que la memoria retoma el movimiento, la repetición deja de ser inercia y se vuelve fidelidad viva por desplazamiento justo.",
    h_features: "Referentes estructurantes",
    h_questions: "Referentes de activación",
    hint_fold: "desplegar",
    example_title: "Formulación canónica",
    example:
      "1) Si un gesto se repite sin vibración: « Yuyarina réoriente ». 2) Si un ritual se vuelve rutina: « Yuyarina introduit la variation ». 3) Si el sentido se apaga lentamente: « Yuyarina remet la marche ».",
    features: [
      "Estatus: sello regulador del Ennéagone espiral.",
      "Vínculo matricial: conecta la memoria vibratoria con la dirección poiética.",
      "Función principal: reactivación del sentido en prácticas vueltas lineales o mecánicas.",
      "Naturaleza: ni Katûsýs, ni Balakallpa, ni Katûvýsqun — interfaz espiral de regeneración del sentido en el acto.",
      "Frecuencia armónica: 286.",
      "Tipo: catalizador de regeneración del sentido.",
      "Dimensiones de acción: prácticas rituales ; gesto artístico o performativo ; lenguaje simbólico ; memorias fractales debilitadas."
    ],
    questions: [
      "¿El gesto continúa mientras la vibración se ha retirado?",
      "¿Se trata de una repetición necesaria o de una rutina que ha perdido su eje?",
      "¿El sentido pide corrección o desplazamiento poiético interior?",
      "¿Qué fuente memorial debe ser recordada antes de cualquier variación?",
      "¿Conviene identificar el fragmento en erosión, recordar yuyay, introducir rina y cerrar con la verbalización del soplo recuperado?"
    ],
    h_family: "Afinidades posœnnoïales",
    family_1:
      "<p><strong>Posición en la Katûvýs:</strong> el Sceau de Yuyarina se sitúa en la intersección de <span translate=\"no\" class=\"po-lex-protect\">Tiqqunbahu</span> y los <span translate=\"no\" class=\"po-lex-protect\">Takimarah</span>. Actúa como arranque de relanzamiento simbólico en todo <span translate=\"no\" class=\"po-lex-protect\">Àpákan</span> donde el impulso inicial se ha vuelto inercia. Relanza la espiral de significación sin romper la estructura: por deslizamiento, por resonancia, por giro sutil.</p>",
    family_2:
      "<p><strong>Entidad isquniana asociada:</strong> <span translate=\"no\" class=\"po-lex-protect\">Yuyarīnâ</span> es la emanación operativa del Sceau de Yuyarina. Recompone lo que se deshilacha cuando el sentido se erosiona por repetición, devuelve sostén a la práctica, plasticidad a la forma y memoria activa a la dirección. En la lógica <span translate=\"no\" class=\"po-lex-protect\">Isqun</span> → <span translate=\"no\" class=\"po-lex-protect\">Threnisqun</span>, condensa la recuperación del eje en gesto situado.</p>",
    h_wordbuild: "Posicionamientos y comparaciones",
    word_blocks: [
      {
        head: "Formación del nombre",
        text:
          "Yuyarina proviene del quechua yuyay — memoria, pensamiento vivo — y rina — marche, direction, passage. La composición nombra una memoria que vuelve a ponerse en movimiento, una conciencia que recupera su trayectoria, una fidelidad viva que rehúsa la inercia."
      },
      {
        head: "Funcionamiento ritual-simbólico",
        text:
          "Identificar el fragmento de práctica en erosión. Recordar la fuente memorial, yuyay. Introducir un desplazamiento poiético, rina: inflexión, variación, reinterpretación. Cerrar con una verbalización del nuevo soplo sentido para inscribir la recuperación en la conciencia operativa."
      },
      {
        head: "Tabla de activación",
        text:
          "Pérdida de sentido en un ritual: repetición automática, variación justa. Gesto vaciado de su vibración: mecanización del cuerpo, reencarnación simbólica. Lenguaje vaciado de poder: fórmulas muertas, reescritura intuitiva. Memoria ritual borrada: olvido del origen, reinscripción vibratoria."
      },
      {
        head: "Alcance filosófico",
        text:
          "Todo lo vivo se erosiona. El desgaste del sentido pertenece a lo real. Yuyarina transforma esa erosión en variación creadora: el sentido no se restaura como objeto, se despliega otra vez en la espiral. La costumbre recupera trayectoria, el gesto recobra curva, la memoria se vuelve marche."
      }
    ],
    word_notes: [
      "Yuyarina no corrige desde fuera ; reorienta desde dentro.",
      "La variación justa se vuelve fidelidad viva antes que traición a la forma.",
      "Actúa cuando el acto se mantiene mientras su carga interna se deshilacha.",
      "Frase operativa: « Yuyarina : reconozco el desgaste, recuerdo la memoria, introduzco la variación justa, y el gesto recupera su curva en la espiral. »"
    ]
  };

  function getFallback(lang){
    var l = normLang(lang) || "fr";
    if (l === "en") return FALLBACK_EN;
    if (l === "es") return FALLBACK_ES;
    return FALLBACK_FR;
  }

  function getAxisLexId(node){
    try{
      return node.getAttribute("data-po-lex-id") || "";
    }catch(e){
      return "";
    }
  }

  function getAxisData(node, lang){
    var l = normLang(lang) || "fr";
    var base = getFallback(l);
    var out = {};
    for (var k in base) out[k] = base[k];

    var lexId = getAxisLexId(node);
    if (lexId){
      var entry = getLexiconEntry(lexId);
      if (entry){
        var termFR = pickTerm(entry, "fr");
        if (termFR) out.title = termFR;

        if (l === "fr"){
          var dsFR = pickDefShort(entry, "fr");
          if (dsFR) out.def_short = dsFR;

          var dlFR = pickDefLong(entry, "fr");
          if (dlFR) out.def_long = dlFR;

          var fFR = pickArray(entry, "fr", "features");
          if (fFR && fFR.length) out.features = fFR;

          var qFR = pickArray(entry, "fr", "questions");
          if (qFR && qFR.length) out.questions = qFR;
        }
      }
    }

    return out;
  }

  function applyToAxis(node){
    var lang = getLang();
    var data = getAxisData(node, lang);

    var chipUrls = (data && Array.isArray(data.chip_urls) && data.chip_urls.length) ? data.chip_urls : [
      IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_286
    ];

    setSlotImgSrc(node, "title_img", chipUrls[0] || IMG_IDEOGRAM_CONCEPT, data.title || "");

    setSlotText(node, "title", data.title);
    setSlotText(node, "kicker", data.kicker);
    setSlotText(node, "h_def", data.h_def);

    var chips = Array.isArray(data.chips) ? data.chips : [];
    setSlotText(node, "chip_1", chips[0] || "");
    setSlotText(node, "chip_2", chips[1] || "");
    setSlotText(node, "chip_3", chips[2] || "");

    setSlotImgSrc(node, "chip_1_img", chipUrls[0] || IMG_IDEOGRAM_CONCEPT, chips[0] || "Idéogramme conceptuel");
    setSlotImgSrc(node, "chip_2_img", chipUrls[1] || IMG_IDEOGRAM_FUNCTION, chips[1] || "Idéogramme fonctionnel");
    setSlotImgSrc(node, "chip_3_img", chipUrls[2] || IMG_GUIDE_NUMBER_286, chips[2] || "Nombre guide 286");

    setSlotHTML(node, "def_short", clampStr(data.def_short));
    setSlotHTML(node, "def_long", clampStr(data.def_long));

    setSlotText(node, "h_features", data.h_features);
    setSlotText(node, "hint_fold", data.hint_fold);
    renderList(node, "features", data.features);

    setSlotText(node, "h_questions", data.h_questions);
    setSlotText(node, "hint_fold2", data.hint_fold);
    renderList(node, "questions", data.questions);
    renderExampleBox(node, "example_box", data.example_title, data.example);

    setSlotText(node, "h_family", data.h_family);
    setSlotText(node, "hint_fold3", data.hint_fold);
    setSlotHTML(node, "family_1", data.family_1);
    setSlotHTML(node, "family_2", data.family_2);

    setSlotText(node, "h_wordbuild", data.h_wordbuild);
    renderWordBlocks(node, "wordbuild_blocks", data.word_blocks);
    renderList(node, "wordbuild_notes", data.word_notes);

    setSlotText(node, "cta_translate", data.cta_translate);
  }

  function applyAll(lang){
    var activeLang = normLang(lang) || getLang();
    var nodes = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<nodes.length;i++){
      applyToAxis(nodes[i]);
    }
    initAudioEverywhere(activeLang);
  }

  function hasLexiconReady(){
    try{
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
      if (window.PO_LEXICON_META && window.PO_LEXICON_META.lexique_simplifie_fr) return true;
    }catch(e){}
    return false;
  }

  function init(){
    var existing = readStoredLang();
    if (!existing){
      storeLang(detectBrowserLang());
    }

    applyAll(getLang());

    window.addEventListener("po:lexicon-ready", function(){
      __PO_PROTECT_RE__ = null;
      applyAll(getLang());
    });

    try{
      var mo = new MutationObserver(function(muts){
        for (var i=0;i<muts.length;i++){
          if (muts[i].type === "attributes" && muts[i].attributeName === "lang"){
            applyAll(getLang());
            notifyLocaleChanged();
            break;
          }
        }
      });
      if (document && document.documentElement){
        mo.observe(document.documentElement, { attributes:true });
      }
    }catch(e){}

    if (!hasLexiconReady()){
      var tries = 0;
      var maxTries = 24;
      var it = setInterval(function(){
        tries++;
        if (hasLexiconReady() || tries >= maxTries){
          clearInterval(it);
          __PO_PROTECT_RE__ = null;
          applyAll(getLang());
        }
      }, 250);
    }
  }

  window.PoKatupirsia5SceauDeYuyarinaTextsFR_EN_ES_20260307 = {
    init: init,
    getLang: getLang,
    normLang: normLang,
    setLang: function(raw){
      var l = normLang(raw) || "fr";
      storeLang(l);
      __PO_PROTECT_RE__ = null;
      applyAll(l);
      notifyLocaleChanged();
      return l;
    },
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.init = init;
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = function(lang){
    return window.PoKatupirsia5SceauDeYuyarinaTextsFR_EN_ES_20260307.setLang(lang);
  };

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  }else{
    init();
  }

})();
